// extracted by mini-css-extract-plugin
module.exports = {"smartgenerator":"smartgenerator_smartgenerator__TTvd_","compare":"smartgenerator_compare__GIC52"};